export default function (attrs) {
    return Object.keys(attrs.$attr)
        .map(x => ({
            key: attrs.$attr[x],
            value: attrs[x]
        }))
        .map(x => `${ x.key }="${ x.value }"`)
        .join(' ');
}



// WEBPACK FOOTER //
// ./Client/app/common/helpers/stringifyAttributes.js